import React from 'react';
import { Link } from 'react-router-dom';

const FEATURES = [
  { href: '/find-honey', img: '/card-find-honey.jpg', label: 'Find Local Honey' },
  { href: '/report-swarm', img: '/card-report-swarm.jpg', label: 'Report a Swarm' },
  { href: '/advertise', img: '/card-advertise.jpg', label: 'Advertise' },
  { href: '/find-bee-club', img: '/card-find-club.jpg', label: 'Find a Bee Club' },
];

export default function PublicFeatureNav({ current }) {
  return (
    <div className="py-8 px-4 mt-8">
      <div className="max-w-md mx-auto">
        <p className="text-xs text-stone-400 text-center mb-4 uppercase tracking-wider">Explore Thrive Beekeeping</p>
        <div className="grid grid-cols-2 gap-3">
          {FEATURES.map(f => (
            <Link key={f.href} to={f.href} className={`bg-white rounded-xl border overflow-hidden hover:shadow-lg hover:border-amber-400 transition-all group ${f.href === current ? 'border-amber-400 ring-1 ring-amber-200' : 'border-amber-200'}`}>
              <img src={f.img} alt={f.label} className="w-full h-24 object-cover" />
              <div className="p-2.5 text-center">
                <span className="text-sm font-bold text-stone-700 group-hover:text-amber-700">{f.label}</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
